import { useFlag } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import {
  isAvailableSelector,
  isExternalFormsAvailableSelector,
  isSalesforceRoutingAvailableSelector,
  isHubspotRoutingAvailableSelector,
  isTeamsHubspotRoutingAvailableSelector
} from 'features/routing/selectors'

export const useBillingFeaturesAccess = () => {
  const isRoutingFormsAvailable = useSelector(isAvailableSelector)
  const isExternalFormsAvailable = useSelector(isExternalFormsAvailableSelector)
  const isBetaSalesforceRoutingFlagEnabled = useFlag('raven_salesforce_routing_feature')
  const isSalesforceRoutingAvailable = useSelector(isSalesforceRoutingAvailableSelector)
  const isHubspotRoutingAvailable = useSelector(isHubspotRoutingAvailableSelector)
  const isTeamsHubspotRoutingAvailable = useSelector(isTeamsHubspotRoutingAvailableSelector)
  const isTeamsHubspotRoutingFlagEnabled = useFlag('raven_hubspot_routing_teams_plan_feature')

  return {
    isRoutingFormsAvailable,
    isExternalFormsAvailable,
    isSalesforceRoutingAvailable: isBetaSalesforceRoutingFlagEnabled || isSalesforceRoutingAvailable,
    isHubspotRoutingAvailable: (isTeamsHubspotRoutingFlagEnabled && isTeamsHubspotRoutingAvailable) || isHubspotRoutingAvailable
  }
}
